import {Col, Row} from 'react-bootstrap'
import Link from 'next/link'
import LandingPageTile from '../components/LandingPageTile'
import jsonApiClient from '../utils/jsonApiClient'
import LandingPageContainer from '../components/LandingPageContainer'
import LandingPageHead from '../components/LandingPageHead'

export async function getStaticProps() {
  const jsonApi = jsonApiClient()
  const pageArray = await jsonApi.findAll('page', {
    filter: {
      slug: 'locations'
    },
    include: 'children'
  })

  const page = pageArray.data[0]

  return {
    props: {
      page: page
    },
    revalidate: 60
  }
}

function Locations({page}) {
  return <>
    <LandingPageHead page={page} />
    <LandingPageContainer page={page}>
      <Row>
        {page.children.map(child => (
          <Col xs={12} md={3} className="mb-4" key={child.id}>
            <Link href={`/tutoring/${child.slug}`} passHref legacyBehavior>
              <LandingPageTile page={child} />
            </Link>
          </Col>
        ))}
      </Row>
    </LandingPageContainer>
  </>
}

export default Locations
